import { Checkbox, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { TransactionSource } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionOriginFilterProps {
  originSet: Set<string>
  handleOriginSelection: (source: string) => Set<string>
}

const TransactionOriginFilter: React.FC<TransactionOriginFilterProps> = ({
  originSet,
  handleOriginSelection,
}) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Transaction Origin'} />
      </div>
      <Checkbox
        label={<Trns source={'Virtual'} />}
        onClick={(): void => {
          handleOriginSelection(TransactionSource.Virtual)
        }}
        isSelected={originSet.has(TransactionSource.Virtual)}
      />
      <Checkbox
        label={<Trns source={'Physical'} />}
        onClick={(): void => {
          handleOriginSelection(TransactionSource.Physical)
        }}
        isSelected={originSet.has(TransactionSource.Physical)}
      />
      <Checkbox
        label={<Trns source={'Other'} />}
        onClick={(): void => {
          handleOriginSelection(TransactionSource.Other)
        }}
        isSelected={originSet.has(TransactionSource.Other)}
      />
    </div>
  )
}

export default TransactionOriginFilter
